var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.format === 1 || _vm.format === 3)?_c('span',[_vm._v(_vm._s(_vm.symbol))]):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm.$n(_vm.value, { minimumFractionDigits: _vm.minimumFractionDigits, }))+" ")]),(_vm.format === 0 || _vm.format === 2)?_c('span',[_vm._v(_vm._s(_vm.symbol))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }